import { AfterViewInit, Directive, ElementRef, inject, OnDestroy } from '@angular/core';
import { PluginListenerHandle } from '@capacitor/core';
import { KEYBOARD_TOKEN, KeyboardProvider, PLATFORM_TOKEN, PlatformProvider } from '../tokens';
import { KeyboardInfo } from '@capacitor/keyboard';

@Directive({
  standalone: true,
  selector: '[iosKeyboardFix]'
})
export class IosKeyboardFixDirective implements AfterViewInit, OnDestroy {
  private readonly elementRef: ElementRef = inject(ElementRef);
  private readonly platform: PlatformProvider = inject(PLATFORM_TOKEN);
  private readonly keyboard: KeyboardProvider = inject(KEYBOARD_TOKEN);

  private keyboardWillShowListener?: PluginListenerHandle;
  private keyboardWillHideListener?: PluginListenerHandle;

  ngAfterViewInit(): void {
    if (this.platform.isiOS) {
      this.setupKeyboardListeners();
    }
  }

  ngOnDestroy(): void {
    this.removeKeyboardListeners();
  }

  private async setupKeyboardListeners(): Promise<void> {
    const hostElement: HTMLElement = this.elementRef.nativeElement as HTMLElement;

    this.keyboardWillShowListener = await this.keyboard.addListenerWillShow((info: KeyboardInfo) => {
      hostElement.style.transform = `translateY(-${info.keyboardHeight}px)`;
      hostElement.style.paddingBottom = '0';
    });

    this.keyboardWillHideListener = await this.keyboard.addListenerWillHide(() => {
      hostElement.style.transform = 'translateY(0)';
      hostElement.style.paddingBottom = '';
    });
  }

  private async removeKeyboardListeners(): Promise<void> {
    await this.keyboardWillShowListener?.remove();
    await this.keyboardWillHideListener?.remove();
  }
}
